//@ts-nocheck

const formatVideoLength = (timeString = '') => {
    if (!timeString || typeof timeString !== 'string') return 'Invalid Length Format';

    const parts = timeString.split(':');
    if (parts.length !== 3) return 'Invalid Length Format';

    const [hoursStr, minutesStr, secondsStr] = parts;
    const hours = Number(hoursStr);
    const minutes = Number(minutesStr);
    const seconds = Number(secondsStr);

    // check if all are valid numbers
    if (
        isNaN(hours) ||
        isNaN(minutes) ||
        isNaN(seconds)
    ) return 'Invalid Length Format';

    const outputParts = [];
    if (hours) outputParts.push(`${hours}hr`);
    if (minutes) outputParts.push(`${minutes}min`);
    if (seconds) outputParts.push(`${seconds}sec`);

    // in case 00:00:00
    if (!outputParts.length) return '0sec';

    return outputParts.join(' ');
};

const extractVimeoId = (url = '') => {
    if (!url || typeof url !== 'string') return null;
    // Match patterns like: vimeo.com/123456 or player.vimeo.com/video/123456
    const match = url.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)([0-9]+)/);
    return match ? match[1] : null;
};

const getVimeoThumbnail = (vimeoId = '') => {
    if (!vimeoId) return null;
    // Vimeo CDN thumbnail URL pattern
    return `https://i.vimeocdn.com/video/${vimeoId}.jpg`;
};

export const CXAHubInterpreter = (content = {}) => {
    const attributes = content.attributes;
    // console.log("Interpreting CXAHub content with attributes:", attributes);
    const preBuiltAuthor = attributes?.speaker?.data?.attributes || attributes?.speaker?.attributes || {};
    const formattedVideoLength = formatVideoLength(attributes?.videoLength);
    // determine status from publishDate
    let status = "currently out";
    if (attributes?.publishDate) {
        const publishDate = new Date(attributes.publishDate);
        const now = new Date();
        if (publishDate > now) {
            status = "coming soon";
        }
    }
    const date = new Date(attributes?.publishDate);
    const formatted = date.toLocaleString('default', { month: 'long' }) + ' ' + date.getDate();
    
    // Extract Vimeo video ID and generate thumbnail if embed is Vimeo
    const vimeoId = extractVimeoId(attributes?.embedMedia);
    const videoThumbnail = vimeoId ? getVimeoThumbnail(vimeoId) : null;
    
    return {
        id: content.id,
        title: attributes?.title,
        publishDate: attributes?.publishDate,
        formattedPublishDate: formatted,
        industries: attributes?.industries?.data?.map(industry => industry?.attributes?.title) || [],
        topics: attributes?.topics?.attributes?.title || attributes?.topics?.data?.attributes?.title || [],
        series: attributes?.series?.attributes?.title || attributes?.series?.data?.attributes?.title || [],
        public: attributes?.public != null ? attributes?.public : false,
        speakerFullName: preBuiltAuthor?.authorFullName || null,
        speakerTitle: preBuiltAuthor?.authorTitle || "",
        speakerLink: preBuiltAuthor?.authorLink|| "",
        speakerImage: preBuiltAuthor?.authorImage?.attributes?.url || preBuiltAuthor?.authorImage?.data?.attributes?.url || "",
        description: attributes?.description,
        cardDescription: attributes?.cardDescription,
        episode: attributes?.episode,
        season: attributes?.season,
        insights: attributes?.insights,
        embedMedia: attributes?.embedMedia,
        videoThumbnail,
        videoLength: formattedVideoLength,
        status,
        referenceList: attributes?.referenceList,
        seo: attributes?.seo,
        source: "cxa-hub"
    }
}
